export default function isAndroid () {
  return /(android)/i.test(navigator.userAgent);
}
